import { memo as Memo, useMemo } from 'react'

//* Components
import Container from 'components/common/Container'
import Text from 'components/common/Text'
import InformativeSlider from 'components/common/InformativeSlider'

//* Styles
import InformativeSliderGalleryStyle from './style'

const InformativeSliderGallery = Memo(({ title, description, sliderItems, bgColor = 'WineBerry', first = false }) => {
	const topInformation = useMemo(() => {
		return (
			(title || description) && (
				<Container row>
					<div className='col-9 col-t-12 col-m-12 isg-info-container'>
						{title && <Text tag={'h2'} className={`h3 font-ping-bolder isg-title`} text={title} />}

						{description && <Text tag={'h3'} className={`h4 font-ping isg-description`} text={description} />}
					</div>
				</Container>
			)
		)
	}, [title, description])
	return (
		<InformativeSliderGalleryStyle>
			<Container first={first} section full>
				{topInformation}

				<InformativeSlider bgColor={bgColor} sliderItems={sliderItems} />
			</Container>
		</InformativeSliderGalleryStyle>
	)
})

export default InformativeSliderGallery
